import { render, staticRenderFns } from "./ReportBlockedComponent.vue?vue&type=template&id=464259da&scoped=true"
import script from "./ReportBlockedComponent.vue?vue&type=script&lang=js"
export * from "./ReportBlockedComponent.vue?vue&type=script&lang=js"
import style0 from "./ReportBlockedComponent.vue?vue&type=style&index=0&id=464259da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464259da",
  null
  
)

export default component.exports